// extracted by mini-css-extract-plugin
export default {"search-bar":"SearchBar_search-bar__voO7N","search-bar-content":"SearchBar_search-bar-content__PMG5g","slideInFromTop":"SearchBar_slideInFromTop__XsSuD"};